import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonComponent, SvgIconComponent } from '@woolworthsnz/styleguide';

@Component({
	selector: 'recipe-no-meal-plans',
	templateUrl: './no-meal-plans.component.html',
	styleUrls: ['./no-meal-plans.component.scss'],
	standalone: true,
	imports: [SvgIconComponent, ButtonComponent]
})
export class NoMealPlansComponent {
	@Output() learnHowItWorksClick = new EventEmitter<void>();

	public handleLearnHowItWorksClick(): void {
		this.learnHowItWorksClick.emit();
	}
}
